import React from "react";
import { FieldProps } from "./models";

interface HiddenFieldProps extends FieldProps<any> {}

export const HiddenFieldComponent = (props: HiddenFieldProps) => {
  const { formData } = props;

  return <input type="hidden" value={formData != null ? JSON.stringify(formData) : ""} />;
};

export const HiddenField = HiddenFieldComponent;
